module.exports = __webpack_public_path__ + "media/images/portal/i-2-e3b40f3da26edc12b42657fe3fc0227a.png";